module.exports = __webpack_public_path__ + "static/media/BannerImage.59987cd2.png";